export const countries = [
  { id:'germany',       flag:'🇩🇪', name:'Germany' },
  { id:'uk',            flag:'🇬🇧', name:'United Kingdom' },
  { id:'usa',           flag:'🇺🇸', name:'USA' },
  { id:'australia',     flag:'🇦🇺', name:'Australia' },
  { id:'canada',        flag:'🇨🇦', name:'Canada' },
  { id:'sweden',        flag:'🇸🇪', name:'Sweden' },
  { id:'netherlands',   flag:'🇳🇱', name:'Netherlands' },
  { id:'france',        flag:'🇫🇷', name:'France' },
  { id:'italy',         flag:'🇮🇹', name:'Italy' },
  { id:'spain',         flag:'🇪🇸', name:'Spain' },
  { id:'denmark',       flag:'🇩🇰', name:'Denmark' },
  { id:'norway',        flag:'🇳🇴', name:'Norway' },
  { id:'finland',       flag:'🇫🇮', name:'Finland' },
  { id:'switzerland',   flag:'🇨🇭', name:'Switzerland' },
  { id:'austria',       flag:'🇦🇹', name:'Austria' },
  { id:'belgium',       flag:'🇧🇪', name:'Belgium' },
  { id:'china',         flag:'🇨🇳', name:'China' },
  { id:'japan',         flag:'🇯🇵', name:'Japan' },
  { id:'southkorea',    flag:'🇰🇷', name:'South Korea' },
  { id:'turkey',        flag:'🇹🇷', name:'Turkey' },
  { id:'malaysia',      flag:'🇲🇾', name:'Malaysia' },
  { id:'newzealand',    flag:'🇳🇿', name:'New Zealand' },
  { id:'ireland',       flag:'🇮🇪', name:'Ireland' },
  { id:'portugal',      flag:'🇵🇹', name:'Portugal' },
  { id:'czechrepublic', flag:'🇨🇿', name:'Czech Republic' },
  { id:'poland',        flag:'🇵🇱', name:'Poland' },
  { id:'hungary',       flag:'🇭🇺', name:'Hungary' },
  { id:'russia',        flag:'🇷🇺', name:'Russia' },
  { id:'uae',           flag:'🇦🇪', name:'UAE' },
  { id:'singapore',     flag:'🇸🇬', name:'Singapore' },
];